<footer class="tchekFooter">
  <div class="text-center copyright">Copyright © {{year}} Tchek</div>
</footer>


// WEBPACK FOOTER //
// ./src/app/element/footer/footer.component.html